import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';
import { Grid2 as Grid } from '@mui/material';
import { Button, Metadata, NumberField, NumberSelect, TextField } from '../common';
import * as React from 'react';

interface Props extends BaseDialogProps {
    readonly onCreate: (name: string, privacy: number, description: string, maxSize: number, metadata: string) => void;
}

interface State extends BaseDialogState {
    readonly name: string;
    readonly privacy: number;
    readonly description: string;
    readonly maxSize: number;
    readonly metadata: string;
}

export class CreateGroupDialog extends BaseDialog<Props, State> {
    state = this.initState();

    protected renderContent(): React.JSX.Element {
        const {
            name,
            privacy,
            description,
            maxSize,
            metadata,
        } = this.state;

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label="Name"
                        value={name}
                        onChange={this.updateName}
                        variant="outlined"
                        fullWidth={true}
                    />
                </Grid>
                <Grid size={12}>
                    <NumberSelect
                        label="Privacy"
                        labelId={`select-privacy`}
                        value={privacy}
                        onChange={this.handleChangePrivacy}
                    >
                        <option key={0} value={0}>
                            {'Open'}
                        </option>
                        <option key={1} value={1}>
                            {'Apply'}
                        </option>
                        <option key={2} value={2}>
                            {'Invite Only'}
                        </option>
                    </NumberSelect>
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Description"
                        value={description}
                        onChange={this.updateDescription}
                        variant="outlined"
                        fullWidth={true}
                    />
                </Grid>
                <Grid size={12}>
                    <NumberField
                        label="Max Size"
                        value={maxSize}
                        onChange={this.updateMaxSize}
                        fullWidth={true}
                        variant="outlined"
                    />
                </Grid>
                <Grid size={12}>
                    <Metadata
                        styled={this.props.styled}
                        label="Metadata"
                        text={metadata}
                        onChange={this.handleChangeMetadata}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Create" onClick={this.onCreate} variant="contained" disabled={!this.validate()} />
        );
    }

    protected initState(): State {
        return {
            name: '',
            privacy: 0,
            description: '',
            maxSize: 50,
            metadata: '',
        };
    }

    private updateName = (name: string) => this.setState({ name });

    private handleChangePrivacy = (privacy: number) => this.setState({ privacy });

    private updateDescription = (description: string) => this.setState({ description });

    private updateMaxSize = (maxSize: number) => this.setState({ maxSize });

    protected handleChangeMetadata = (metadata: string) => this.setState({ metadata });

    private onCreate = () => {
        const { name, privacy, description, maxSize, metadata } = this.state;
        if (!this.validate()) {
            return;
        }
        this.props.onCreate(name, privacy, description, maxSize, metadata);
        this.onClose();
    };

    private validate(): boolean {
        const { name } = this.state;
        return name !== '';
    }
}
